import { SvgIcon, SvgIconProps } from "@sol/uikit/core/icons/SvgIcon";

export const GraduationCap02 = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props} width="24" height="24" viewBox="0 0 24 24">
            <g id="graduation-cap-02">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.9761 1.56612C11.6069 1.1902 12.393 1.1902 13.0238 1.56612L22.6078 7.27759C23.3093 7.69562 23.5067 8.54325 23.2 9.20305V13.9495C23.2 14.5018 22.7523 14.9495 22.2 14.9495C21.6477 14.9495 21.2 14.5018 21.2 13.9495V10.6937L19.9389 11.4452L19.9389 17.3926C19.9389 18.1001 19.5651 18.755 18.9559 19.1148L13.5639 22.2987C12.5924 22.8724 11.3812 22.8525 10.4291 22.2473L5.48111 19.102C4.90372 18.735 4.55401 18.0983 4.55401 17.4142V11.739L1.39214 9.85468C0.416001 9.27296 0.415995 7.85931 1.39214 7.27759L10.9761 1.56612ZM6.55401 12.9308V17.4142L11.502 20.5594C11.8194 20.7611 12.2231 20.7678 12.5469 20.5766L17.9389 17.3926L17.9389 12.637L13.0238 15.5661C12.393 15.9421 11.6069 15.9421 10.9761 15.5661L6.55401 12.9308ZM20.8632 8.56613L12 3.28418L3.13673 8.56613L12 13.8481L20.8632 8.56613Z"
                    className="fill-current"
                />
            </g>
        </SvgIcon>
    );
};
